import React from "react";
import {Button, Card, DatePicker, Form, Input, Select, Space, Table} from "antd";
import {
    AuthenticatedGetToApi,
    AuthenticatedPostToApi,
    FILEDOWNLOADAuthenticatedPostToApi,
    UnauthenticatedPostToApi
} from "../../helpers/api";
import {DownloadOutlined} from "@ant-design/icons";
const { Option } = Select;

function ICAdmin() {
    const [AdminData, setAdminData] = React.useState({})
    const [allDeptColumnsF1, setallDeptColumnsF1] = React.useState([])
    const [allDeptColumnsF2, setallDeptColumnsF2] = React.useState([])
    const [allDeptColumnsF3, setallDeptColumnsF3] = React.useState([])
    const [allUserLoginsColumnsF1, setAllUserLoginsColumnsF1] = React.useState([])
    const [allUserLoginsColumnsF2, setAllUserLoginsColumnsF2] = React.useState([])
    const [allUserLoginsColumnsF3, setAllUserLoginsColumnsF3] = React.useState([])
    const [allUserLoginsColumnsF4, setAllUserLoginsColumnsF4] = React.useState([])
    const [allUserLoginsColumnsF5, setAllUserLoginsColumnsF5] = React.useState([])

    const allDeptColumns = [
        {
            title: 'AgencyCode',
            dataIndex: 'AgencyCode',
            
        },
        {
            title: 'DeptCode',
            dataIndex: 'DeptCode',
            filterSearch: true,
            onFilter: (value, r) => r.DeptCode?.includes(value),
            filters:allDeptColumnsF2
        },
        {
            title: 'DeptName',
            dataIndex: 'DeptName',
            filterSearch: true,
            onFilter: (value, r) => r.DeptName?.includes(value),
            filters:allDeptColumnsF3
        },
    ];

    const allUserLoginsColumns = [
        {
            title: 'AuthLevel',
            dataIndex: 'AuthLevel',
            filterSearch: true,
            onFilter: (value, r) => r.AuthLevel?.includes(value),
            filters:allUserLoginsColumnsF1
        },
        {
            title: 'Dept',
            dataIndex: 'Dept',
            filterSearch: true,
            onFilter: (value, r) => r.Dept?.includes(value),
            filters:allUserLoginsColumnsF2
        },
        {
            title: 'FirstName',
            dataIndex: 'FirstName',
            filterSearch: true,
            onFilter: (value, r) => r.FirstName?.includes(value),
            filters:allUserLoginsColumnsF3
        },
        {
            title: 'LastName',
            dataIndex: 'LastName',
            filterSearch: true,
            onFilter: (value, r) => r.LastName?.includes(value),
            filters:allUserLoginsColumnsF4
        },
        {
            title: 'MuniCode',
            dataIndex: 'MuniCode',
            filterSearch: true,
            onFilter: (value, r) => r.MuniCode?.includes(value),
            filters:allUserLoginsColumnsF5
        },
    ];

    const LoadAdminData = async () => {
        let r = await AuthenticatedPostToApi('/api/admin/get_admin_data')
        setAdminData(r)
        return(r)
    }

    React.useEffect(()=>{
        LoadAdminData().then(r=>{
            let fT1 = []
            let fT2 = []
            let fT3 = []
            let uT1 = []
            let uT2 = []
            let uT3 = []
            let uT4 = []
            let uT5 = []
            if(r.allDept){
                for(let j of r.allDept){
                    fT1.push({text: j.AgencyCode, value: j.AgencyCode})
                    fT2.push({text: j.DeptCode, value: j.DeptCode})
                    fT3.push({text: j.DeptName, value: j.DeptName})
                }
                   
            }

            if(r.allUserLogins){
                for(let j of r.allUserLogins){
                    uT1.push({text: j.AuthLevel, value: j.AuthLevel})
                    uT2.push({text: j.Dept, value: j.Dept})
                    uT3.push({text: j.FirstName, value: j.FirstName})
                    uT4.push({text: j.LastName, value: j.LastName})
                    uT5.push({text: j.MuniCode, value: j.MuniCode})
                }

            }
            
            setallDeptColumnsF1(fT1)
            setallDeptColumnsF2(fT2)
            setallDeptColumnsF3(fT3)
            setAllUserLoginsColumnsF1(uT1)
            setAllUserLoginsColumnsF2(uT2)
            setAllUserLoginsColumnsF3(uT3)
            setAllUserLoginsColumnsF4(uT4)
            setAllUserLoginsColumnsF5(uT5)
        });
    },[])



    return (
        <div>
            
            {(AdminData && AdminData.allDept) &&
                <Card size="small" style={{ width: "100%", marginTop:10 }} title="ALL InfoCop Departments">
                    
                    <Table size="small" dataSource={AdminData.allDept} columns={allDeptColumns} pagination={true} showSearch={true}/>

                </Card>
            }

            {(AdminData && AdminData.allUserLogins) &&
                <Card size="small" style={{ width: "100%", marginTop:10 }} title="ALL InfoCop Report Users">

                    <Table size="small" dataSource={AdminData.allUserLogins} columns={allUserLoginsColumns} pagination={true} showSearch={true}/>

                </Card>
            }

        </div>
    );
}

export default ICAdmin;